/** Module to check elkjop environment
 * Check if environment is for sellers or for end users
 *
 * This is a singleton class
 */

// TODO: Check if this should be module ora class

let instance = null

export default class EnvCtrl {

    _hostname = null;
    _isCustomer = false;
    chainsData = null;

    constructor(chainsData) {

        // Singleton statement
        if(instance)
            return instance;

        this._hostname = window.location.hostname;

        if(chainsData)
            this.chainsData = chainsData
        else
            console.warn('missing chains data');
    }

    isCustomer() {

        let chain = this.chainsData.find( r => {
            return r.customers.hostname === this._hostname;
        })
        let _hostname = window.location.hostname;

        return !!chain;
    }

    /** Get chain Id from url
     *
     * @returns {*|null}
     */
    getCustomerChainId() {
        let chain = this.chainsData.find( r => {
            return r.customers.hostname === this._hostname;
        })

        return chain.id || null;
    }

    getCustomerChainData() {
        let chain = this.chainsData.find( r => {
            return r.customers.hostname === this._hostname;
        })

        return chain || null;
    }

    /** Get chain Id from url
     *
     * @returns {*|null}
     */
    getCustomerTenant() {
        let chain = this.chainsData.find( r => {
            return r.customers.hostname === this._hostname;
        })

        return chain.customers.tenant || null;
    }

    /** Get chain Id from url
     *
     * @returns {*|null}
     */
    getCustomerClientId() {
        let chain = this.chainsData.find( r => {
            return r.customers.hostname === this._hostname;
        })

        return chain.customers.clientId || null;
    }

    getCustomerSignUpRef() {
        let chainId = this.getCustomerChainId();
        return chainId ? this.chainsData.find( r => { return r.id === chainId; }).customers['signup:ref'] : null;
    }

    getCustomerSignInLink() {
        let policy = 'B2C_1A_SUSI_B2C';
        let chainId = this.getCustomerChainId();
        let chain = this.chainsData.find( r => { return r.id === chainId; });
        let queryParams = {
            p: policy,
            client_id: chain.customers.clientId,
            nonce: 'defaultNonce',
            redirect_uri: window.location.href.replace('#/', ''),
            scope: 'openid',
            response_type: 'id_token',
            prompt: 'login',
            ui_locales: chain.locale
        }

        let str = [];
        for (let p in queryParams) {
            if (queryParams.hasOwnProperty(p)) {
                // str.push(encodeURIComponent(p) + "=" + encodeURIComponent(params[p]));
                str.push(p + "=" + queryParams[p]);
            }
        }

        return `${chain.customers.authUrl}/${chain.customers.tenant}/oauth2/v2.0/authorize?${str.join('&')}`;
    }

    getCustomerAuthority() {
        let chainId = this.getCustomerChainId();
        let chain = this.chainsData.find( r => { return r.id === chainId; });

        return chain.customers.authUrl + '/' + this.getCustomerTenant();
        // return chain.customers.authUrl + '/' + this.getCustomerTenant();
    }
}



// WEBPACK FOOTER //
// ./src/custom/epoq/_modules/EnvCtrl.js